import React from "react";

import clubbieLogoWhite from "../../assets/images/clubbie_logo_white.svg";

function ClubbieLoader({ size = 48 }) {
  return (
    <img
      src={clubbieLogoWhite}
      alt="Loading"
      className="animate-spin"
      style={{ width: size, height: size }}
    />
  );
}

export default ClubbieLoader;
